import { List, ListItem, ListItemIcon, ListSubheader } from '@mui/material';
import ListItemText, { listItemTextClasses } from '@mui/material/ListItemText';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

import { SxPropsOverrides } from '../../../shared/types/markup';
import { applySxOverrides } from '../../../shared/helpers/functions/markup';

export default function CheckMarkList({
  title,
  styles = {},
  items,
}: {
  title: string;
  styles?: {
    list?: SxPropsOverrides;
    listSubheader?: SxPropsOverrides;
  };
  items: {
    title: string;
    description: string;
  }[];
}) {
  return (
    <List
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        ...applySxOverrides(styles?.list),
      }}
      subheader={
        <ListSubheader
          sx={(theme) => ({
            ...theme.typography.h4,
            mt: 0,
            mb: 1,
            ...applySxOverrides(styles?.listSubheader, theme),
          })}
          disableSticky
          disableGutters
          component="h4"
        >
          {title}
        </ListSubheader>
      }
    >
      {items.map((item, index) => (
        <ListItem
          key={index}
          sx={{
            p: 0,
            alignItems: 'flex-start',
            lineHeight: '20px',
          }}
          disableGutters
        >
          <ListItemIcon
            sx={(theme) => ({
              color: theme.palette.primary.light,
              minWidth: 'auto',
              mr: '16px',
            })}
          >
            <CheckRoundedIcon />
          </ListItemIcon>
          <ListItemText
            primary={`${item.title} `}
            secondary={item.description}
            sx={(theme) => ({
              m: 0,
              [`& .${listItemTextClasses.primary}`]: {
                ...theme.typography.body2,
                fontWeight: 500,
                display: 'inline',
              },
              [`& .${listItemTextClasses.secondary}`]: {
                ...theme.typography.body1,
                display: 'inline',
              },
            })}
          />
        </ListItem>
      ))}
    </List>
  );
}
